import { Checkbox } from '../Checkbox';
import { Content, Header, LabelText, Wrapper } from './ExpandableSection.styles';
import type { ExpandableSectionProps } from './ExpandableSection.types';

export function ExpandableSection({
  label,
  expanded,
  onToggle,
  children,
  hideCheckbox = false,
}: ExpandableSectionProps) {
  return (
    <Wrapper>
      <Header>
        <LabelText>{label}</LabelText>
        {!hideCheckbox && <Checkbox checked={expanded} onChange={onToggle} />}
      </Header>
      {expanded && <Content>{children}</Content>}
    </Wrapper>
  );
}
